import { isWorkbookRefreshRequired } from "../../utils/common-utils";
import { CompanyActionTypeEnum } from "./company-action";
import { CompanyState, WorkbookRecords } from "./company-state";

const initialState: CompanyState = {
  companyDetails: {},
  isPdsDetailsUnavailable: false,
  pdsEligibilityDetails: {},
  companyList:null,
  workbookRecords: {} as WorkbookRecords,
  timelineRecords: [] as any,
  workbookSignedUrl: "",
  activeMonthKey: "",
  accountBuckets: {
    itHasUnBucketedAccounts: false,
    isWorkBookRefreshRequired: false,
    isWarningDialogOpen: false,
    workbookRefreshStatus: "",
    accountBucketInfo: new Map(),
    sourceMappings: [],
    unBucketedAccounts: new Map(),
  },
  cashAccounts:{
    hasConflictDetected: false,
    formType: "CONFIRMED",
  },
  loanAccounts:{
    hasConflictDetected: false,
    formType: "CONFIRMED",
  }
};

export const companyReducer = (state: CompanyState = initialState, action: any): CompanyState => {
  switch (action.type) {
    case CompanyActionTypeEnum.SET_PDS_ELIGIBLE_DETAILS: {
      return {
        ...state,
        pdsEligibilityDetails:  action.data,
      };
    }
    case CompanyActionTypeEnum.IS_PDS_DETAILS_UNAVAILABLE: {
      return {
        ...state,
        isPdsDetailsUnavailable: action.data
      }
    }
    case CompanyActionTypeEnum.SET_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: action.data,
      };
    case CompanyActionTypeEnum.SET_ALL_COMPANY_LIST:
      return {
        ...state,
        companyList: action.data,
      };

    case CompanyActionTypeEnum.SET_WORKBOOK_RECORDS:
      return {
        ...state,
        workbookRecords: action.data,
      };
    case CompanyActionTypeEnum.SET_TIMELINE_RECORDS:
      return {
        ...state,
        timelineRecords: action.data,
      };
    case CompanyActionTypeEnum.SET_WORKBOOK_URL:
      return {
        ...state,
        workbookSignedUrl: action.data.presignedURL,
        activeMonthKey: action.data.key,
      };
    case CompanyActionTypeEnum.SET_ACCOUNT_MAPPINGS:
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          sourceMappings: action.data,
        },
      };
    case CompanyActionTypeEnum.IS_WORKBOOK_REFRESH_REQUIRED:
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          isWorkBookRefreshRequired: action.data,
        },
      };
    case CompanyActionTypeEnum.WORKBOOK_REFRESH_STATUS:
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          workbookRefreshStatus: action.data,
        },
      };

    case CompanyActionTypeEnum.SET_ACCOUNT_BUCKET_INFO:
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          accountBucketInfo: action.data,
          isWorkBookRefreshRequired: isWorkbookRefreshRequired(action.data),
        },
      };
    case CompanyActionTypeEnum.SET_UN_BUCKETED_ACCOUNTS: {
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          unBucketedAccounts: action.data,
          itHasUnBucketedAccounts: Boolean(action.data.size),
        },
      };
    }
    case CompanyActionTypeEnum.SET_WARN_DIALOG_STATUS: {
      return {
        ...state,
        accountBuckets: {
          ...state.accountBuckets,
          isWarningDialogOpen: action.data,
        },
      };
    }
    case CompanyActionTypeEnum.SET_CONFLICT_DETECTED_STATUS: {
      return {
        ...state,
        cashAccounts: {
          ...state.cashAccounts,
          hasConflictDetected: action.data,
        },
      };
    }
    case CompanyActionTypeEnum.SET_CASH_ACCOUNT_FORM_TYPE: {
      return {
        ...state,
        cashAccounts: {
          ...state.cashAccounts,
          formType: action.data,
        },
      };
    }
    case CompanyActionTypeEnum.SET_LOAN_ACCOUNT_FORM_TYPE: {
      return {
        ...state,
        loanAccounts: {
          ...state.loanAccounts,
          formType: action.data,
        },
      };
    }
    case CompanyActionTypeEnum.SET_LOAN_ACCOUNT_CONFLICT_DETECTED_STATUS: {
      return {
        ...state,
        loanAccounts: {
          ...state.loanAccounts,
          hasConflictDetected: action.data,
        },
      };
    }
    case CompanyActionTypeEnum.RESET_TO_INITIAL_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
